import { Box } from "@mui/material";
import { ReactNode } from "react";

interface PrivacyPageRootFrameProps {
    children: ReactNode;
    constrainToViewport?: boolean;
}

export default function PrivacyPageRootFrame({
    children,
    constrainToViewport = false,
}: PrivacyPageRootFrameProps) {
    return (
        <Box
            sx={{
                px: "10%",
                py: 4,
                overflowWrap: "break-word",
                ...(constrainToViewport && {
                    boxSizing: "border-box",
                    display: "flex",
                    height: "calc(100dvh - var(--header-height, 0px))",
                    maxHeight: "calc(100dvh - var(--header-height, 0px))",
                    minHeight: 0,
                    minWidth: 0,
                    overflow: "hidden",
                    width: "100%",
                }),
            }}
        >
            {children}
        </Box>
    );
}
